// Copyright (c) Docugami, Inc. All rights reserved.**/

import { useState } from "react";
import styled from "styled-components";
import loadingGif from "assets/loading_project.gif";
import { useTimeout } from "hooks/Timeout";

export const LoadingImage = styled.div`
    display: flex;
    height: 100%;
    width: 100%;
    background-image: url(${loadingGif});
    background-repeat: no-repeat;
    background-position: center center;
`

enum LoadingAnimationState {
    Delay,
    Animating,
    Complete
}

interface LoadingPlaceholderProps {
    placeholderDelayTimeMs?: number;
    minimumPlaceholderTimeMs?: number;
    isLoading: boolean;
    loadingPlaceholder?: React.ReactNode;
    children?: React.ReactNode;
}

export const LoadingPlaceholder = (props: LoadingPlaceholderProps) => {
    const [animationState, setAnimationState] = useState<LoadingAnimationState>(!!props.isLoading ? LoadingAnimationState.Delay : LoadingAnimationState.Complete);

    useTimeout(
        () => setAnimationState(!!props.isLoading ? LoadingAnimationState.Animating : LoadingAnimationState.Complete),
        animationState === LoadingAnimationState.Delay ? (props.placeholderDelayTimeMs ?? 500) : undefined
    );

    useTimeout(
        () => setAnimationState(LoadingAnimationState.Complete),
        animationState === LoadingAnimationState.Animating ? (props.minimumPlaceholderTimeMs ?? 1000) : undefined
    );

    if (animationState === LoadingAnimationState.Complete && !props.isLoading) {
        return (
            <>
                {props.children}
            </>
        )
    }
    else {
        return (
            <>
                {props.loadingPlaceholder}
            </>
        )
    }
}
